export const version = "transactions/5.0.10";
//# sourceMappingURL=_version.js.map